<a [routerLink]="[list?.list_url]" (click)="onSeeMoreNavigation()">
  <div
    [ngClass]="{
      complete: !isHome,
    }"
    class="list as-pointer"
    style="
    background-image: url('{{
      list?.picture !== null && list?.picture !== undefined
        ? list?.picture
        : urlTemporal
    }}');"
    (click)="goDetails()"
    >
    <div class="texts">
      <p
        class="as-font as-font-white as-font-bold as-font-24 as-text-overflow"
        [ngClass]="{
        half: isHome,
      }"
        >
        {{ list?.name | titlecase }}
      </p>
      <p class="as-font as-font-white as-font-16 as-font-normal">
        {{ list?.total_items || list?.items?.length }}
        {{ 'LISTS.products' | translate }}
      </p>
    </div>
    @if (list?.name === 'Favoritos' && !isHome) {
      <app-detail-list-card [list]="list?.items" />
    }
  </div>
</a>
